<template>
    <div class="expenses-index">
        <expense-row
            v-for="expense in expenses"
            :key="expense.id"
            :expense="expense"
            @click="gotoExpense(expense)"
        />
        <button
            class="btn floating-new-btn"
            @click="newExpense"
        >
            <i class="fa fa-plus" />
        </button>
        <button
            class="btn floating-refresh-btn"
            @click="load"
        >
            <i
                class="fas fa-sync-alt"
                :class="{'fa-spin' : loading}"
            />
        </button>
    </div>
</template>

<script>
import Service from '../../services/EmployeeExpensesService';
import ExpenseRow from './ExpenseRow';

export default {
    components: {
        ExpenseRow,
    },
    data () {
        return {
            loading: false,
            expenses: [],
        };
    },
    mounted () {
        this.load();
    },
    methods: {
        load () {
            this.loading = true;
            Service.index({
                engineer_mode: 1,
            }).then(res => {
                this.expenses = res.data.data;
                window.setTimeout(() => {
                    this.loading = false;
                }, 1000);
            }).catch(err => {
                console.error(err);
                this.setErrorMessage('Failed to load expenses');
            });
        },
        gotoExpense (expense) {
            this.$router.push({ name: 'engineer.expenses.edit', params: {id: expense.id} })
        },

        newExpense () {
            this.$router.push({ name: 'engineer.expenses.new' })
        },
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/engineer/ExpensesIndex.vue